import { render } from "./Article.vue?vue&type=template&id=503ba6d8&scoped=true&lang=html&bindings={\"data\":\"props\",\"ArticleType\":\"data\",\"formatdate\":\"options\"}"
import script from "./Article.vue?vue&type=script&lang=ts"
export * from "./Article.vue?vue&type=script&lang=ts"

import "./Article.vue?vue&type=style&index=0&id=503ba6d8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-503ba6d8"

export default script